import { Injectable } from '@angular/core';
import {BaseApiService} from '../../base-service/base-api.service';

@Injectable()
export class ValidationService extends BaseApiService {

    getValidationGroupUIMaps() {
        return this.get('Foundation/ValidationResource/Group/UIMap');
    }
}
